import React from 'react';
import DOMPurify from 'dompurify';

const RichTextDisplay = ({ content, className = "" }) => {
  // Sanitize the HTML content to prevent XSS attacks
  const sanitizedContent = DOMPurify.sanitize(content || '');

  // If content is empty or just whitespace, return null
  if (!content || content.trim() === '' || content.trim() === '<p><br></p>') {
    return null;
  }

  return (
    <>
      <style jsx>{`
        .rich-text-display h1 {
          font-size: 1.5rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
          color: inherit;
        }
        .rich-text-display h2 {
          font-size: 1.25rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
          color: inherit;
        }
        .rich-text-display h3 {
          font-size: 1.125rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
          color: inherit;
        }
        .rich-text-display strong {
          font-weight: bold;
        }
        .rich-text-display em {
          font-style: italic;
        }
        .rich-text-display u {
          text-decoration: underline;
        }
        .rich-text-display p {
          margin-bottom: 1rem;
        }
        .rich-text-display p:last-child {
          margin-bottom: 0;
        }
        .rich-text-display ul {
          list-style-type: disc;
          margin-left: 1.5rem;
          margin-bottom: 1rem;
        }
        .rich-text-display ol {
          list-style-type: decimal;
          margin-left: 1.5rem;
          margin-bottom: 1rem;
        }
        .rich-text-display li {
          margin-bottom: 0.25rem;
        }
        .rich-text-display a {
          color: #4285f4;
          text-decoration: underline;
        }
        .rich-text-display a:hover {
          color: #3367d6;
        }
      `}</style>
      <div 
        className={`rich-text-display ${className}`}
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        style={{
          lineHeight: '1.6',
        }}
      />
    </>
  );
};

export default RichTextDisplay;
